import * as commonConsts from '../../pages/common/CommonConsts';
import * as constants from '../../utils/Constants';
import {
  getDuplicateAddressDetail,
  isPrimaryContact,
  getDuplicateAddressDetailWthOutAddressNotChanged
} from '../../utils/Helper';
import { getApplicantDetails } from '../../utils/notificationChange/Helper';
import {
  getApplicant,
  getOrganisationType,
  getSingleAddressDetail,
  getExistingAddressDetail
} from '../../utils/notificationChange/Helper';
import { getFormatAddressFromAddressLine } from '../../utils/FormatHelper';
import moment from 'moment';
import { getAllDocuments } from '../../utils/SupportingDocumentHelper';

const formattedOrganisationNotificationChangeJson = (
  application,
  twoFA,
  authorityInformation,
  licenceFullDetail,
  notificationChangeDetail
) => {
  const {
    organisationLicence,
    organisationPersonalDetails,
    organisationAuthorityHolder,
    accountant,
    trader,
    branch,
    fundraisingDetail,
    supportingDocument
  } = notificationChangeDetail;

  const { authorisedContacts } = organisationLicence || {};
  const { licenceInfo } = licenceFullDetail;
  const { twoFaVerified, data } = twoFA;

  const organisationType = getOrganisationType(licenceInfo?.organisationLicensee, organisationLicence);

  let associatedIndividuals = [];
  let associatedOrganisations = [];
  let premiseList = [];
  let individualApplicantDetails = {};

  let personalDetailsData = {};
  let organisationLicenceData = {};

  const licenseeRowId = licenceInfo?.organisationLicensee?.organisationDetail?.id;
  const licenseeIntegrationId = licenceInfo?.organisationLicensee?.organisationDetail?.integrationId;
  let licenseeBusinessName = licenceInfo?.organisationLicensee?.organisationDetail?.businessName;
  let existingPrimaryContact = licenceInfo?.organisationLicensee?.primaryContact
    ? licenceInfo.organisationLicensee.primaryContact
    : null;
  let existingIndividualApplicant = getApplicant(data, licenceInfo);
  let individualApplicantIsPrimaryContact = null;

  //#region Personal Details
  if (organisationPersonalDetails?.id) {
    let organisationPersonalDetailAddresses = [];

    if (organisationPersonalDetails?.residentialAddress) {
      organisationPersonalDetailAddresses.push(organisationPersonalDetails?.residentialAddress);
    }

    if (organisationPersonalDetails?.postalAddress) {
      organisationPersonalDetailAddresses.push(organisationPersonalDetails?.postalAddress);
    }

    const secondaryContactNumber =
      organisationPersonalDetails && organisationPersonalDetails.secondaryContactNumber
        ? {
            prefix: organisationPersonalDetails.secondaryContactNumber.prefix,
            number: organisationPersonalDetails.secondaryContactNumber.number
          }
        : twoFaVerified
        ? {
            prefix: data?.phoneNumber
              ? data?.phoneNumber.split('-').length > 1
                ? data?.phoneNumber.split('-')[0]
                : null
              : null,
            number: data?.phoneNumber
              ? data?.phoneNumber.split('-').length > 1
                ? data?.phoneNumber.split('-')[1]
                : null
              : null
          }
        : {
            prefix: null,
            number: null
          };

    // associatedIndividuals = associatedIndividuals.concat({
    //   id: organisationPersonalDetails?.id,
    //   integrationId: organisationPersonalDetails?.integrationId,
    //   firstName: organisationPersonalDetails?.firstName,
    //   middleName: organisationPersonalDetails?.middleName,
    //   surname: organisationPersonalDetails?.lastName,
    //   dateOfBirth: organisationPersonalDetails?.dateOfBirth,
    //   twoFaVerified: twoFA.data ? true : false,
    //   contactPart: {
    //     emailAddress: organisationPersonalDetails.emailAddress,
    //     mobileNo: organisationPersonalDetails?.primaryContactNumber,
    //     phoneNo:
    //       secondaryContactNumber.prefix && secondaryContactNumber.number
    //         ? `${secondaryContactNumber.prefix}-${secondaryContactNumber.number}`
    //         : ''
    //   },
    //   addresses: organisationPersonalDetailAddresses,
    //   roles: ['Contact Person'],
    //   roleDetails: [
    //     {
    //       roleType: 'Contact Person',
    //       isPrimary: false //default to false, will be updated if the individual applicant is now the primary contact
    //     }
    //   ]
    // });
    // individualApplicantDetails = {
    //   id: organisationPersonalDetails?.id,
    //   integrationId: organisationPersonalDetails?.integrationId,
    //   firstName: organisationPersonalDetails?.firstName,
    //   middleName: organisationPersonalDetails?.middleName,
    //   surname: organisationPersonalDetails?.lastName,
    //   dateofbirth: organisationPersonalDetails?.dateOfBirth,
    //   placeOfBirth: null,
    //   twoFaVerified: twoFA.data ? true : false,
    //   contactPart: {
    //     emailAddress: organisationPersonalDetails.emailAddress,
    //     mobileNo:
    //       organisationPersonalDetails?.primaryContactNumber?.prefix ||
    //       organisationPersonalDetails?.primaryContactNumber?.number
    //         ? `${organisationPersonalDetails?.primaryContactNumber?.prefix}-${organisationPersonalDetails?.primaryContactNumber?.number}`
    //         : organisationPersonalDetails?.primaryContactNumber
    //         ? organisationPersonalDetails?.primaryContactNumber
    //         : ``,
    //     phoneNo:
    //       organisationPersonalDetails?.secondaryContactNumber?.prefix ||
    //       organisationPersonalDetails?.secondaryContactNumber?.number
    //         ? `${organisationPersonalDetails?.secondaryContactNumber?.prefix}-${organisationPersonalDetails?.secondaryContactNumber?.number}`
    //         : organisationPersonalDetails?.secondaryContactNumber
    //         ? organisationPersonalDetails?.secondaryContactNumber
    //         : ``
    //   },
    //   addresses: organisationPersonalDetailAddresses,
    //   relatedOrgName: licenseeBusinessName,
    //   roles: ['Contact Person'],
    //   roleDetails: [
    //     {
    //       roleType: 'Contact Person',
    //       startDate: organisationPersonalDetails?.startDate,
    //       isPrimary: false //default to false, will be updated if the individual applicant is now the primary contact
    //     }
    //   ]
    // };
  } //else {
  // individualApplicantDetails = {
  //   id: existingIndividualApplicant?.id,
  //   integrationId: existingIndividualApplicant?.integrationId,
  //   firstName: existingIndividualApplicant?.firstName,
  //   middleName: existingIndividualApplicant?.middleName,
  //   surname: existingIndividualApplicant?.lastName,
  //   dateofbirth: existingIndividualApplicant?.dateOfBirth,
  //   twoFaVerified: twoFA.data ? true : false,
  //   contactPart: {
  //     emailAddress: existingIndividualApplicant.emailAddress,
  //     mobileNo:
  //       existingIndividualApplicant?.primaryContactNumber?.prefix ||
  //       existingIndividualApplicant?.primaryContactNumber?.number
  //         ? `${existingIndividualApplicant?.primaryContactNumber?.prefix}-${existingIndividualApplicant?.primaryContactNumber?.number}`
  //         : existingIndividualApplicant?.primaryContactNumber
  //         ? existingIndividualApplicant?.primaryContactNumber
  //         : ``,
  //     phoneNo:
  //       existingIndividualApplicant?.secondaryContactNumber?.prefix ||
  //       existingIndividualApplicant?.secondaryContactNumber?.number
  //         ? `${existingIndividualApplicant?.secondaryContactNumber?.prefix}-${existingIndividualApplicant?.secondaryContactNumber?.number}`
  //         : existingIndividualApplicant?.secondaryContactNumber
  //         ? existingIndividualApplicant?.secondaryContactNumber
  //         : ``
  //   },
  //   relatedOrgName: licenseeBusinessName,
  //   roles: ['Contact Person'],
  //   roleDetails: [
  //     {
  //       roleType: 'Contact Person',
  //       startDate: existingIndividualApplicant?.startDate,
  //       isPrimary: false //default to false, will be updated if the individual applicant is now the primary contact
  //     }
  //   ]
  // };
  //}
  //#endregion

  //#region Organisation Licensee
  if (organisationLicence && organisationLicence?.businessName) {
    let registeredOfficeAddress = {};
    let premiseAddresses = [];
    licenseeBusinessName = organisationLicence?.businessName;
    if (
      organisationLicence?.addressRegisteredOfficeValue?.lookupValue ||
      organisationLicence?.addressRegisteredOfficeValue?.enterManually === true
    ) {
      premiseAddresses = premiseAddresses.concat(
        getSingleAddressDetail(organisationLicence.addressRegisteredOfficeValue, 'Registered Office')
      );
    } else {
      premiseAddresses = premiseAddresses.concat(
        getExistingAddressDetail(licenceInfo.organisationLicensee.organisationDetail.premises, 'Registered Office')
      );
    }

    if (organisationLicence?.sameAsRegisteredOffice && organisationLicence?.sameAsRegisteredOffice?.length > 0) {
      if (
        organisationLicence.sameAsRegisteredOffice[0] !== undefined &&
        organisationLicence.sameAsRegisteredOffice[0] == true
      ) {
        if (Object.keys(organisationLicence?.addressRegisteredOfficeValue).length === 0) {
          registeredOfficeAddress = getFormatAddressFromAddressLine(
            organisationLicence.addressRegisteredOfficePlaceHolder,
            'Business'
          );
        } else {
          if (
            organisationLicence?.addressRegisteredOfficeValue?.lookupValue ||
            organisationLicence?.addressRegisteredOfficeValue?.enterManually === true
          ) {
            registeredOfficeAddress = getSingleAddressDetail(
              organisationLicence.addressRegisteredOfficeValue,
              'Business'
            );
          } else {
            registeredOfficeAddress = getExistingAddressDetail(
              licenceInfo.organisationLicensee.organisationDetail.premises,
              'Business'
            );
          }
        }

        premiseAddresses = premiseAddresses.concat(registeredOfficeAddress);
      }

      if (
        organisationLicence.sameAsRegisteredOffice[1] !== undefined &&
        organisationLicence.sameAsRegisteredOffice[1] == true
      ) {
        if (Object.keys(organisationLicence?.addressRegisteredOfficeValue).length === 0) {
          registeredOfficeAddress = getFormatAddressFromAddressLine(
            organisationLicence.addressRegisteredOfficePlaceHolder,
            'Postal'
          );
        } else {
          if (
            organisationLicence?.addressRegisteredOfficeValue?.lookupValue ||
            organisationLicence?.addressRegisteredOfficeValue?.enterManually === true
          ) {
            registeredOfficeAddress = getSingleAddressDetail(
              organisationLicence.addressRegisteredOfficeValue,
              'Postal'
            );
          } else {
            registeredOfficeAddress = getExistingAddressDetail(
              licenceInfo.organisationLicensee.organisationDetail.premises,
              'Postal'
            );
          }
        }

        premiseAddresses = premiseAddresses.concat(registeredOfficeAddress);
      }
    }

    if (organisationLicence.otherAddresses?.length > 0) {
      organisationLicence.otherAddresses.map((addr) => {
        if (addr !== undefined && addr !== null) {
          const addressAlreadyAdded = premiseAddresses.find((a) => a.addressType === addr.addressType);
          if (addressAlreadyAdded === undefined) {
            if (addr?.lookupValue || addr?.enterManually === true) {
              premiseAddresses = premiseAddresses.concat(getSingleAddressDetail(addr));
            }
          }
        }
      });
    }

    let addressTypes = ['Registered Office', 'Business', 'Postal'];
    if (premiseAddresses.length < 3) {
      premiseAddresses.map((addr) => {
        addressTypes = addressTypes.filter((a) => a !== addr.addressType);
      });

      addressTypes.forEach((addrType) => {
        premiseAddresses = premiseAddresses.concat(
          getExistingAddressDetail(licenceInfo.organisationLicensee.organisationDetail.premises, addrType)
        );
      });
    }

    if (premiseAddresses.length > 0) {
      premiseList = premiseList.concat({
        businessName: organisationLicence?.businessName,
        id: licenseeRowId,
        integrationId: licenseeIntegrationId,
        roles: ['Registered Office'],
        premiseAddresses: premiseAddresses
      });
    }
  }
  //#endregion

  //#region Authority Holder Name Change
  if (organisationAuthorityHolder?.authorityHolderName) {
    organisationLicenceData = {
      id: organisationLicence?.id ? organisationLicence.id : licenseeRowId ? licenseeRowId : null,
      integrationId: organisationLicence?.integrationId
        ? organisationLicence.integrationId
        : licenseeIntegrationId
        ? licenseeIntegrationId
        : null,
      name: organisationAuthorityHolder.authorityHolderName,
      roles: [],
      roleDetails: [
        {
          roleType: 'Applicant'
        }
      ]
    };
  }
  //#endregion

  //#region Authorised Contacts
  if (authorisedContacts?.newContacts?.length > 0) {
    authorisedContacts.newContacts.forEach((newContact) => {
      associatedIndividuals = associatedIndividuals.concat({
        firstName: newContact?.firstName,
        middleName: newContact?.middleName,
        surname: newContact?.lastName,
        contactPart: {
          emailAddress: newContact?.emailAddress,
          mobileNo: newContact?.mobileNo,
          phoneNo:
            newContact?.secondaryContactNumber?.prefix && newContact?.secondaryContactNumber?.number
              ? `${newContact.secondaryContactNumber?.prefix}-${newContact.secondaryContactNumber?.number}`
              : ''
        },
        addresses: getDuplicateAddressDetail(newContact?.businessAddress, newContact?.postalAddress),
        roleDetails: [
          {
            roleType: 'Contact Person',
            startDate: moment(new Date()).format('DD/MM/YYYY'),
            isPrimary: false //default to false
          }
        ],
        roles: ['Contact Person'],
        relatedOrgName: licenseeBusinessName
      });
    });
  }

  if (authorisedContacts?.removedContacts?.length > 0) {
    authorisedContacts.removedContacts.forEach((removedContact) => {
      associatedIndividuals = associatedIndividuals.concat({
        id: removedContact?.id,
        integrationId: removedContact?.integrationId,
        firstName: removedContact?.firstName,
        middleName: removedContact?.middleName ? removedContact.middleName : null,
        surname: removedContact?.lastName,
        roles: [],
        roleDetails: [
          {
            roleType: 'Contact Person',
            endDate: moment(new Date()).format('DD/MM/YYYY'),
            isPrimary: false //default to false
          }
        ]
      });
    });
  }
  //#endregion

  //#region Primary Contact
  if (organisationLicence?.primaryContact && existingPrimaryContact) {
    const newPrimaryContactId = organisationLicence?.primaryContact;
    const newExistingPrimaryContactPerson = licenceInfo?.organisationLicensee?.authorisedContacts.find(
      (contact) => contact?.id === newPrimaryContactId
    );
    const oldExistingContactPerson = licenceInfo?.organisationLicensee?.authorisedContacts.find(
      (contact) => contact?.id === existingPrimaryContact
    );

    //See if the new primary contact has already be added to associated individuals
    let indexNew = -1;
    let newPrimaryContactPerson = associatedIndividuals.filter((x) => x?.id === newPrimaryContactId);
    if (Object.keys(newPrimaryContactPerson).length === 0) {
      newPrimaryContactPerson = associatedIndividuals.filter((ind) =>
        ind?.middleName
          ? `${ind?.firstName.toLowerCase()} ${ind?.middleName.toLowerCase()} ${ind?.surname.toLowerCase()}`
          : `${ind?.firstName.toLowerCase()} ${ind?.surname.toLowerCase()}` === newPrimaryContactId.toLowerCase()
      );
    }

    //if we found the new primary contact in associated individuals, get their index.
    if (Object.keys(newPrimaryContactPerson).length > 0) {
      indexNew = associatedIndividuals.findIndex(
        (ind) =>
          ind.firstName === newPrimaryContactPerson[0].firstName &&
          ind.middleName === newPrimaryContactPerson[0].middleName &&
          ind.lastName === newPrimaryContactPerson[0].lastName
      );
    }

    if (indexNew !== -1) {
      associatedIndividuals[indexNew].roleDetails[0].isPrimary = true;

      //Update old contact person
      //See if the old primary contact has already be added to associated individuals
      if (oldExistingContactPerson) {
        const indexOld = associatedIndividuals.findIndex((ind) => ind?.id === existingPrimaryContact);
        if (indexOld !== -1) {
          associatedIndividuals[indexOld].roleDetails[0].isPrimary = true;
        } else {
          associatedIndividuals = associatedIndividuals.concat({
            id: oldExistingContactPerson?.id,
            integrationId: oldExistingContactPerson?.integrationId,
            firstName: oldExistingContactPerson?.firstName,
            middleName: oldExistingContactPerson?.middleName ? oldExistingContactPerson?.middleName : null,
            surname: oldExistingContactPerson?.lastName,
            roles: [],
            roleDetails: [
              {
                roleType: 'Contact Person',
                isPrimary: false
              }
            ]
          });
        }
      }
    } else {
      if (oldExistingContactPerson?.id !== newPrimaryContactId) {
        //1. Individual Applicant (Person completing form)
        if (existingIndividualApplicant?.id === newPrimaryContactId) {
          associatedIndividuals = associatedIndividuals.concat({
            id: existingIndividualApplicant.id,
            integrationId: existingIndividualApplicant?.integrationId,
            firstName: existingIndividualApplicant?.firstName,
            middleName: existingIndividualApplicant?.middleName ? existingIndividualApplicant?.middleName : null,
            surname: existingIndividualApplicant?.lastName,
            roles: [],
            roleDetails: [
              {
                roleType: 'Contact Person',
                isPrimary: true
              }
            ],
            relatedOrgName: licenseeBusinessName
          });
          //individualApplicantDetails.roleDetails[0].isPrimary = true;
        }
        //2. Existing Contact Person
        else if (newExistingPrimaryContactPerson) {
          associatedIndividuals = associatedIndividuals.concat({
            id: newExistingPrimaryContactPerson.id,
            integrationId: newExistingPrimaryContactPerson?.integrationId,
            firstName: newExistingPrimaryContactPerson?.firstName,
            middleName: newExistingPrimaryContactPerson?.middleName
              ? newExistingPrimaryContactPerson?.middleName
              : null,
            surname: newExistingPrimaryContactPerson?.lastName,
            roles: [],
            roleDetails: [
              {
                roleType: 'Contact Person',
                isPrimary: true
              }
            ],
            relatedOrgName: licenseeBusinessName
          });
        }

        //Update old contact person
        //See if the old primary contact has already be added to associated individuals
        if (oldExistingContactPerson) {
          const indexOldContact = associatedIndividuals.findIndex((ind) => ind?.id === existingPrimaryContact);
          if (indexOldContact !== -1) {
            associatedIndividuals[indexOldContact].roleDetails[0].isPrimary =
              oldExistingContactPerson?.id !== newExistingPrimaryContactPerson?.id ? false : true;
          } else if (existingIndividualApplicant?.id === existingPrimaryContact) {
            individualApplicantIsPrimaryContact = false;
          } else {
            associatedIndividuals = associatedIndividuals.concat({
              id: oldExistingContactPerson?.id,
              integrationId: oldExistingContactPerson?.integrationId,
              firstName: oldExistingContactPerson?.firstName,
              middleName: oldExistingContactPerson?.middleName ? oldExistingContactPerson?.middleName : null,
              surname: oldExistingContactPerson?.lastName,
              roles: [],
              roleDetails: [
                {
                  roleType: 'Contact Person',
                  isPrimary: false
                }
              ]
            });
          }
        }
      }
    }
  }
  //#endregion

  //#region Accountants
  if (accountant) {
    //New Accountants
    if (accountant?.newAccountants?.length > 0) {
      accountant.newAccountants.forEach((newAccountant) => {
        if (newAccountant.partyType === commonConsts.OptionsIndividual) {
          associatedIndividuals = associatedIndividuals.concat({
            firstName: newAccountant?.firstName,
            middleName: newAccountant?.middleName,
            surname: newAccountant?.lastName,
            contactPart: {
              emailAddress: newAccountant?.emailAddress,
              phoneNo: newAccountant?.primaryContactNumber
                ? `${newAccountant.primaryContactNumber?.prefix}-${newAccountant.primaryContactNumber?.number}`
                : ``
              // phoneNo: newAccountant?.secondaryContactNumber
              //   ? `${newAccountant.secondaryContactNumber?.prefix}-${newAccountant.secondaryContactNumber?.number}`
              //   : ``
            },
            addresses: getDuplicateAddressDetail(newAccountant?.businessAddress, newAccountant?.postalAddress),
            qualifications: [
              {
                certificateNumber: newAccountant?.qualification?.certificateNumber,
                certificateName: newAccountant?.qualification?.qualifications,
                details: newAccountant?.qualification?.details
              }
            ],
            roleDetails: [
              {
                roleType: 'Auditor',
                startDate: moment(new Date()).format('DD/MM/YYYY')
              }
            ],
            roles: [],
            relatedOrgName: licenseeBusinessName
          });
        } else {
          associatedOrganisations = associatedOrganisations.concat({
            id: newAccountant?.siebelRowId ? newAccountant?.siebelRowId : null,
            integrationId: newAccountant?.integrationId ? newAccountant?.integrationId : null,
            name:
              newAccountant.organisationSearch?.searchType === commonConsts.OrganisationSearchYincOtherTypeName
                ? newAccountant.organisationSearch?.manualYinc === true
                  ? newAccountant.organisationSearch?.organisationName
                  : newAccountant?.businessName
                : newAccountant?.businessName,
            //newAccountant?.businessName,
            abn: newAccountant?.organisationData?.abn,
            acn: newAccountant?.organisationData?.acn,
            registrationNumber:
              newAccountant.organisationSearch?.searchType === commonConsts.OrganisationSearchYincOtherTypeName
                ? newAccountant.organisationSearch?.manualYinc === true
                  ? newAccountant.organisationSearch?.registrationNumber
                  : newAccountant?.registrationNumber
                : newAccountant?.registrationNumber,
            roleDetails: [
              {
                roleType: 'Auditor',
                startDate: moment(new Date()).format('DD/MM/YYYY')
              }
            ],
            roles: [],
            addresses: getDuplicateAddressDetail(newAccountant?.businessAddress, newAccountant?.postalAddress)
          });

          //New Lead Accountant
          if (newAccountant?.organisationDetails) {
            const leadAuditor = newAccountant?.organisationDetails;
            associatedIndividuals = associatedIndividuals.concat({
              firstName: leadAuditor?.contactFirstName,
              middleName: leadAuditor?.contactMiddleName,
              surname: leadAuditor?.contactLastName,
              contactPart: {
                emailAddress: leadAuditor?.contactEmailAddress,
                phoneNo: leadAuditor?.contactPrimaryContactNumber
                  ? `${leadAuditor?.contactPrimaryContactNumber?.prefix}-${leadAuditor?.contactPrimaryContactNumber?.number}`
                  : ``
              },
              addresses: getDuplicateAddressDetail(
                leadAuditor?.contactBusinessAddress,
                leadAuditor?.contactPostalAddress
              ),
              qualifications: [
                {
                  certificateNumber: leadAuditor?.contactQualification?.certificateNumber,
                  certificateName: leadAuditor?.contactQualification?.qualifications,
                  details: leadAuditor?.contactQualification?.details
                }
              ],
              relatedOrgName: newAccountant?.businessName,
              roles: [],
              roleDetails: [
                {
                  roleType: 'Auditor',
                  startDate: moment(new Date()).format('DD/MM/YYYY')
                }
              ]
            });
          }
        }
      });
    }

    //Updated Accountants
    if (accountant?.existingAccountants?.length > 0) {
      accountant.existingAccountants.forEach((existingAccountant) => {
        if (existingAccountant?.isUpdated) {
          if (existingAccountant.partyType === commonConsts.OptionsIndividual) {
            associatedIndividuals = associatedIndividuals.concat({
              id: existingAccountant?.id,
              integrationId: existingAccountant?.integrationId,
              firstName: existingAccountant?.firstName,
              middleName: existingAccountant?.middleName ? existingAccountant.middleName : null,
              surname: existingAccountant?.lastName,
              qualifications: [
                {
                  certificateNumber: existingAccountant?.qualification?.certificateNumber,
                  certificateName: existingAccountant?.qualification?.qualifications,
                  details: existingAccountant?.qualification?.details
                }
              ],
              roleDetails: [
                {
                  roleType: 'Auditor'
                }
              ],
              roles: []
            });
          } else {
            const isLeadAccountantDetails = existingAccountant?.isLeadAccountantDetails;

            if (isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption1) {
              const leadAuditor = existingAccountant?.leadAuditor;

              associatedIndividuals = associatedIndividuals.concat({
                id: leadAuditor?.id,
                integrationId: leadAuditor?.integrationId,
                firstName: leadAuditor?.firstName,
                middleName: leadAuditor?.middleName ? leadAuditor.middleName : null,
                surname: leadAuditor?.lastName,
                qualifications: [
                  {
                    certificateNumber: leadAuditor?.qualification?.certificateNumber,
                    certificateName: leadAuditor?.qualification?.qualifications,
                    details: leadAuditor?.qualification?.details
                  }
                ],
                roleDetails: [
                  {
                    roleType: 'Auditor'
                  }
                ],
                roles: []
              });
            } else if (isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption2) {
              const newLeadAuditor = existingAccountant?.newLeadAuditor;

              associatedIndividuals = associatedIndividuals.concat({
                firstName: newLeadAuditor?.firstName,
                middleName: newLeadAuditor?.middleName,
                surname: newLeadAuditor?.lastName,
                contactPart: {
                  emailAddress: newLeadAuditor?.emailAddress,
                  phoneNo: newLeadAuditor?.primaryContactNumber
                    ? `${newLeadAuditor?.primaryContactNumber?.prefix}-${newLeadAuditor?.primaryContactNumber?.number}`
                    : ``
                },
                addresses: getDuplicateAddressDetail(newLeadAuditor?.businessAddress, newLeadAuditor?.postalAddress),
                qualifications: [
                  {
                    certificateNumber: newLeadAuditor?.qualification?.certificateNumber,
                    certificateName: newLeadAuditor?.qualification?.qualifications,
                    details: newLeadAuditor?.qualification?.details
                  }
                ],
                relatedOrgName: existingAccountant?.businessName,
                roles: [],
                roleDetails: [
                  {
                    roleType: 'Auditor',
                    startDate: moment(new Date()).format('DD/MM/YYYY')
                  }
                ]
              });
            }
          }
        }
      });
    }

    //Removed Accountants
    if (accountant?.removedAccountants?.length > 0) {
      accountant.removedAccountants.forEach((removedAccountant) => {
        if (removedAccountant?.id && removedAccountant?.integrationId) {
          if (removedAccountant?.partyType === commonConsts.OptionsIndividual) {
            associatedIndividuals = associatedIndividuals.concat({
              id: removedAccountant?.id,
              integrationId: removedAccountant?.integrationId,
              firstName: removedAccountant?.firstName,
              middleName: removedAccountant?.middleName ? removedAccountant.middleName : null,
              surname: removedAccountant?.lastName,
              roles: [],
              roleDetails: [
                {
                  roleType: 'Auditor',
                  endDate: moment(new Date()).format('DD/MM/YYYY')
                }
              ]
            });
          } else {
            const leadAccountant = removedAccountant?.leadAuditor;

            associatedOrganisations = associatedOrganisations.concat({
              id: removedAccountant?.id,
              integrationId: removedAccountant?.integrationId,
              name: removedAccountant?.businessName,
              roles: [],
              roleDetails: [
                {
                  roleType: 'Auditor',
                  endDate: moment(new Date()).format('DD/MM/YYYY')
                }
              ]
            });

            associatedIndividuals = associatedIndividuals.concat({
              id: leadAccountant?.id,
              integrationId: leadAccountant?.integrationId,
              firstName: leadAccountant?.firstName,
              middleName: leadAccountant?.middleName ? leadAccountant.middleName : null,
              surname: leadAccountant?.lastName,
              roles: [],
              roleDetails: [
                {
                  roleType: 'Auditor',
                  endDate: moment(new Date()).format('DD/MM/YYYY')
                }
              ]
            });
          }
        }
      });
    }
  }
  //#endregion

  //#region Traders
  if (trader) {
    if (trader?.newTraders?.length > 0) {
      trader.newTraders.forEach((newTrader) => {
        if (!!!newTrader?.id && !!!newTrader?.integrationId) {
          if (newTrader?.type === commonConsts.OptionsIndividual) {
            associatedIndividuals = associatedIndividuals.concat({
              firstName: newTrader?.firstName,
              middleName: newTrader?.middleName,
              surname: newTrader?.lastName,
              contactPart: {
                emailAddress: newTrader?.emailAddress,
                phoneNo: newTrader?.primaryContact
                  ? `${newTrader?.primaryContact?.prefix}-${newTrader?.primaryContact?.number}`
                  : ``
              },
              addresses: getDuplicateAddressDetail(newTrader?.businessAddress, newTrader?.postalAddress),
              roles: [],
              roleDetails: [
                {
                  roleType: 'Trader',
                  startDate: moment(new Date()).format('DD/MM/YYYY')
                }
              ],
              relatedOrgName: licenseeBusinessName
            });
          } else {
            associatedOrganisations = associatedOrganisations.concat({
              id: newTrader?.orgDataInfo?.data?.siebelRowId,
              integrationId: newTrader?.orgDataInfo?.data?.siebelIntegrationId,
              name: newTrader.organisationName,
              emailAddress: newTrader.organisationEmailAddress,
              phoneNumber:
                newTrader.organisationPrimaryContact.prefix && newTrader.organisationPrimaryContact.number
                  ? `${newTrader.organisationPrimaryContact.prefix}-${newTrader.organisationPrimaryContact.number}`
                  : '',
              addresses: getDuplicateAddressDetail(
                newTrader?.organisationBusinessAddress,
                newTrader?.organisationPostalAddress
              ),
              abn: newTrader?.orgDataInfo?.data?.abn,
              acn: newTrader?.orgDataInfo?.data?.acn,
              registrationNumber:
                newTrader.orgDataInfo.searchCriteria.searchType === commonConsts.OrganisationSearchYincOtherTypeName
                  ? newTrader.registrationNumber
                  : null,
              roleDetails: [
                {
                  roleType: 'Trader',
                  // StartDate: organisation.startDate
                  startDate: moment(new Date()).format('YYYY-MM-DD')
                }
              ],
              roles: []
            });
          }
        }
      });
    }
    if (trader?.removedTraders?.length > 0) {
      trader.removedTraders.forEach((removedTrader) => {
        if (removedTrader?.isExists) {
          if (removedTrader?.type === commonConsts.OptionsIndividual) {
            associatedIndividuals = associatedIndividuals.concat({
              id: removedTrader?.id,
              integrationId: removedTrader?.integrationId,
              firstName: removedTrader?.firstName,
              middleName: removedTrader?.middleName ? removedTrader.middleName : null,
              surname: removedTrader?.lastName,
              roleDetails: [
                {
                  roleType: 'Trader',
                  endDate: moment(new Date()).format('YYYY-MM-DD')
                }
              ],
              roles: []
            });
          } else {
            associatedOrganisations = associatedOrganisations.concat({
              id: removedTrader?.id,
              integrationId: removedTrader?.integrationId,
              name: removedTrader?.businessName,
              roleDetails: [
                {
                  roleType: 'Trader',
                  endDate: moment(new Date()).format('YYYY-MM-DD')
                }
              ],
              roles: []
            });
          }
        }
      });
    }
  }
  //#endregion

  //#region Branches
  if (branch) {
    if (branch?.newBranches?.length > 0) {
      branch.newBranches.forEach((newBranch) => {
        if (newBranch?.type === commonConsts.OptionsOrganisation) {
          associatedOrganisations = associatedOrganisations.concat({
            id: newBranch?.orgDataInfo?.data?.siebelRowId,
            integrationId: newBranch?.orgDataInfo?.data?.siebelIntegrationId,
            name: newBranch.organisationName,
            emailAddress: newBranch.organisationEmailAddress,
            phoneNumber:
              newBranch.organisationPrimaryContact.prefix && newBranch.organisationPrimaryContact.number
                ? `${newBranch.organisationPrimaryContact.prefix}-${newBranch.organisationPrimaryContact.number}`
                : '',
            addresses: getDuplicateAddressDetail(
              newBranch?.organisationBusinessAddress,
              newBranch?.organisationPostalAddress
            ),
            abn: newBranch?.orgDataInfo?.data?.abn,
            acn: newBranch?.orgDataInfo?.data?.acn,
            registrationNumber:
              newBranch?.orgDataInfo?.searchCriteria?.searchType === commonConsts.OrganisationSearchYincOtherTypeName
                ? newBranch?.registrationNumber
                : null,
            roleDetails: [
              {
                roleType: 'Sub-Branch',
                startDate: moment(new Date()).format('YYYY-MM-DD')
              }
            ],
            roles: [],
            relatedOrgName: licenseeBusinessName
          });
        }
      });
    }

    if (branch?.removedBranches?.length > 0) {
      branch.removedBranches.forEach((removedBranch) => {
        if (removedBranch?.isExists) {
          if (removedBranch?.type === commonConsts.OptionsOrganisation) {
            associatedOrganisations = associatedOrganisations.concat({
              id: removedBranch?.id,
              integrationId: removedBranch?.integrationId,
              name: removedBranch?.organisationName,
              roleDetails: [
                {
                  roleType: 'Sub-Branch',
                  endDate: moment(new Date()).format('YYYY-MM-DD')
                }
              ],
              roles: []
            });
          }
        }
      });
    }
  }
  //#endregion

  let contactId;
  if (licenceInfo?.licenceeType === 'Individual') {
    contactId = licenceInfo?.individualLicensee?.id;
  } else {
    contactId = licenceInfo?.organisationLicensee?.organisationDetail?.id;
  }

  const personalDetails = getApplicantDetails(twoFA, organisationPersonalDetails, licenceInfo);
  const individualApplicantResidentailAddress = personalDetails?.residentialAddress
    ? { ...personalDetails?.residentialAddress, addressType: 'Residential' }
    : personalDetails?.residentialAddress;
  const individualApplicantPostalAddress = personalDetails?.postalAddress
    ? { ...personalDetails?.postalAddress, addressType: 'Postal' }
    : personalDetails?.postalAddress;
  let result = {
    agencyId: licenceInfo.agencyId,
    agencyCode: licenceInfo.adgencyCode,
    licenceNumber: licenceInfo.licenceNumber,
    licenceType: licenceInfo.licenceType,
    licenceTypeId: licenceInfo.licenceTypeId,
    licenceId: licenceInfo.licenceId,
    applicationId: application.applicationId,
    contactId: contactId,
    applicationNo: application.applicationNo,
    applicantType: constants.APPLICANT_TYPE_Organisation,
    applicationType: constants.APPLICATION_TYPE_NotificationChange,
    associatedIndividuals: associatedIndividuals,
    associatedOrganisations: associatedOrganisations,
    twoFaVerified: twoFA.data ? true : false,
    fundRaisingDetail: {
      charityObjects: fundraisingDetail?.charityObject,
      natureDuration: fundraisingDetail?.natureDuration,
      financialYearEnd:
        fundraisingDetail?.day && fundraisingDetail?.month
          ? `${fundraisingDetail.day}/${fundraisingDetail.month}`
          : fundraisingDetail?.day,
      directorRemuneration: fundraisingDetail?.directorRemuneration,
      applicantOrgType: fundraisingDetail?.applicantOrgType,
      charityWebsiteUrl: fundraisingDetail?.charityWebsiteUrl
      //registeredwithACNC: registeredAcnc === true ? 'Y' : 'N' TODO: Fix this once ACNC has been plugged in.
    },
    //individualApplicantDetails,
    individualApplicantDetails: {
      roles: [],
      roleDetails: [
        {
          roleType: 'Contact Person',
          isPrimary: individualApplicantIsPrimaryContact
            ? individualApplicantIsPrimaryContact
            : organisationLicence?.primaryContact === personalDetails.id
        }
      ],
      id: personalDetails.id,
      twoFaVerified: data ? true : false,
      firstName: personalDetails.firstName,
      middleName: personalDetails.middleName,
      surname: personalDetails.lastName,
      contactPart: {
        emailAddress: personalDetails.emailAddress,
        mobileNo: personalDetails.primaryContactNumber,
        phoneNo: personalDetails.secondaryContactNumber.prefix
          ? `${personalDetails.secondaryContactNumber.prefix}-${personalDetails.secondaryContactNumber.number}`
          : personalDetails?.secondaryContactNumber?.number
      },
      addresses: getDuplicateAddressDetailWthOutAddressNotChanged(
        individualApplicantResidentailAddress,
        individualApplicantPostalAddress
      )
    },
    organisationApplicantDetails: organisationLicenceData ? organisationLicenceData : null,
    attachments:
      supportingDocument?.documents && supportingDocument?.documents?.length > 0
        ? getAllDocuments(supportingDocument, organisationType)
        : null,
    premisesList: premiseList
  };

  return result;
};

export { formattedOrganisationNotificationChangeJson };
